import React, { useState } from "react"
import Each from "../Each"
import { WithInputType } from '../../components/Inputs'
import { BUTTONS } from "../../Utils/Strings"
import API from '../../ApiConfig'
import cogoToast from "cogo-toast-react-17-fix"
import { ADD_TO_CART, SET_DRAFT_FORM_RECIEPIENT } from "../../Utils/constant"
import BtnLoader from "../BtnLoader"
import { AuthConsole, EMAIL_CHECK, isNumber } from "../../Utils/helper"
import { useDispatch, useSelector } from "react-redux"
import { addItem } from "../../Utils/Redux/CartSlice"
import CartPopupModel from "../../pages/Cart/CartPopupModel"
export default function RecipientForm({ form, fields, handleCancel, onUpdate, isIndex }) {
    const [formData, setFormData] = useState(fields)
    const [loading, setLoading] = useState(false)

    const User=useSelector(state=>state.User)
    const dispatch=useDispatch()
    const [showCartPopup, setShowCartPopup]=useState(false)
    function handleFormChange(value, index) {
        let temp = _.cloneDeep(formData)
        temp[index].value = value
        if (temp[index].type === 'number') {
            if (value.length > 0 && !isNumber(value)){
                temp[index].error = 'Enter valid input'
            }
            else if (value.length > 0 && value.length !== 10) {
                temp[index].error = 'Enter 10 digit number'
            }
            else {
                delete temp[index].error
                if (value.length > 0)
                    temp[index].value = parseInt(value)
            }
        }
        else if(temp[index].type === "email"){
            if(value.length > 0 && !EMAIL_CHECK(value)){
                temp[index].error="Enter valid email"
            }
            else{
                delete temp[index].error
                temp[index].value = value
            }
        }
        else {
            if (value.length > 0)
                delete temp[index].error
        }
        if (value.length === 0 && !temp[index].isRequired) {
            delete temp[index].error
        }
        setFormData(temp)
    }

    function resetForm() {
        setFormData(fields)
        if (handleCancel) {
            handleCancel()
        }
    }

    function validateData() {
        let data = formData
        let isValid = true
        let temp = []
        data.forEach(item => {
            if (item.error)
                isValid = false
            if (item.value != undefined || item.value != null || item.value == '') {
                if (item.isRequired && item.value.length === 0) {
                    isValid = false
                    item.error = "*Required!"
                }
            }
            temp.push(item)
        })
        setFormData(temp)
        if (!isValid) {
            cogoToast.error('Please Enter valid inputs!')
            return
        }
        else
            saveFormData(data)

    }
    async function saveFormData(data) {
        // debugger
        // AuthConsole(data);

        let params = {}
        let isNew = isIndex == 0 || isIndex ? false : true
        // // params.doc_data = {}
        data.forEach(item => {
            params[item.field_name] = item.value
            // if (!isNew) {
                params.form_id = form.form_id
                params.verifier_id=User.id
                params.search_type="other"

            // }
        })
        // if (isNew) {
        //     params.form_id = form.id
        //     params.verifier_id = User.id
        // }
        console.log(params);
        
        setLoading(true)
        API.post(ADD_TO_CART, { ...params })
            .then(res => {
                cogoToast.success(res.data.message)
                dispatch(addItem({...params}))
                setShowCartPopup(true)
                // onUpdate(fields)
            })
            .catch(err => {
                setLoading(false)
                cogoToast.error(err.response.data.message)
            }).finally(() => setLoading(false))
    }
    return <section className="recipient-form">
        {/* <Loader isOpen={loading} /> */}


        {showCartPopup && <CartPopupModel/>}
        <div className='row'>
            <Each of={formData} render={(item, index) => {
                return <div className='col-4 p-1 pt-1 pb-0' key={index}>
                    <WithInputType {...item} onChange={e => handleFormChange(e, index)} />
                </div>
            }} />
        </div>

        <div className='row'>
            <div className='col pl-1'>
                <button className='btn' onClick={e => resetForm()}>Cancel</button>
                <button className='btn btn-primary' disabled={loading} onClick={validateData} style={{ width: "fit-content" }}>
                    {loading ? <BtnLoader label={BUTTONS.SAVE} /> : BUTTONS.SAVE}
                </button>
            </div>
        </div>
    </section>
}
